<div class="host ___dashboard">

  <ng-container *ngIf="destinationPart?.dataService; else noItems">

    <div class="header" *ngIf="destinationPart">
      <div class="left">
        <strong>
          <i class="icon-medium-tint" [class]="destinationPart.menuItem.icon"></i>
          <span>Linking</span>
        </strong>
      </div>
      <div class="right">
        <a *ngIf="!isEdit" href="javascript:void(0)" (click)="isEdit=true">Edit</a>
        <a *ngIf="isEdit" href="javascript:void(0)" (click)="isEdit=false">Exit</a>
      </div>
    </div>
  
    <ng-container *ngIf="isEdit; else viewMode">
  
      <div class="edit">
  
        <div class="selected">
          <div class="title">Selected</div>
          <ul class="items">
            <li *ngFor="let item of selectedData | o2a">
              <a href="#" class="button-outline-dark-sm" (click)="removeItem(item);false;">-</a>
              <a href="#" (click)="false">{{ item.title }}</a>
            </li>
          </ul>

        </div>

        <div class="available">
          <div class="search">
            <input
              class="form-control"
              type="search"
              [(ngModel)]="query"
              placeholder="ID or search query ..."
              (keyup.enter)="loadItems(); false;"
            >
            <a href="#" class="button-primary-sm" [class.disabled]="!query" (click)="!query ? false : loadItems(); false;">Load</a>
          </div>
          <ul class="items">
            <li class="note" *ngIf="!query && !items.length">Load items by ID or search query, then hit [+] to select.</li>
            <li class="loading" *ngIf="isLoading">
              <nguix-dashboard-spinner></nguix-dashboard-spinner>
            </li>
            <li *ngFor="let item of items">              
              <a href="#" class="button-outline-dark-sm" (click)="addItem(item);false;">+</a>
              <a href="#" (click)="false">{{ item.title }}</a>
            </li>
          </ul>
        </div>
  
      </div>
  
      <div class="actions">
        <div class="left">
          <a class="button-outline-dark-sm" href="javascript:void(0)" (click)="isEdit=false">Cancel</a>
        </div>
        <a class="button-primary-sm" href="#" (click)="submit()">Save</a>
      </div>
  
    </ng-container>
  
    <ng-template #viewMode>
  
      <div class="view-none" *ngIf="!hasData; else viewList">
        No items, click Edit to add.
      </div>
  
      <ng-template #viewList>
  
        <ul class="view-list">
          <li *ngFor="let item of currentData | o2a">
            <a href="#" (click)="false">{{ item.title }}</a>
          </li>
        </ul>
  
      </ng-template>
  
    </ng-template>

  </ng-container>

  <ng-template #noItems>
    <div class="view-none">
      No linking items available.
    </div>
  </ng-template>

</div>